export default __webpack_public_path__ + "d2aa68dd8b6f4dc92d1cd19968763f8d.jpg";